import React from "react";
import { connect } from "react-redux";

import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import { splitArr } from "../../../utils/common";

const NutrientTable = ({ nutrientData }) => {
	const nutrientTableEntry = splitArr(nutrientData.nut ? nutrientData.nut : [], 2);
	const columns = [
		{
			Header: "NUTRIENT",
			accessor: "label",
			sortable: false
		},
		{
			Header: "",
			accessor: "data",
			sortable: false,
			Cell: ({ original }) => (
				<span className="font-weight-bold text-primary-dark"> {original.data ? original.data : "-"} </span>
			)
		}
	];

	return (
		<div className="card card-primary p-4 border-0 mt-4">
			<h4 className="text-primary-dark "> Expanded Nutrient Info </h4>
			<div className="row">
				{nutrientTableEntry.map((item, index) => (
					<div className="col-6" key={index}>
						<PaginatedTable data={item} columns={columns} />
					</div>
				))}
			</div>
		</div>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(NutrientTable);
